// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__EZxko","title":"Navbar_title__PjhTw","userInfo":"Navbar_userInfo__yLN2Z","userEmail":"Navbar_userEmail__nRxP4","avatar":"Navbar_avatar__hw2Qh"};